import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { issueReasons } from './constants'

const IssueReasonSelector = ({ value, onChange }) => {
  const { t } = useTranslation()

  return (
    <ComboBox
      fullWidth
      menuItems={issueReasons.map(o => ({ label: t(o.label), value: o.value }))}
      label={t('Motivo')}
      value={value}
      handleChange={onChange}
    />
  )
}

export default IssueReasonSelector
